import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const SUPPORT_PHONE = "0451-74 44 00";
const SUPPORT_PHONE_HREF = "tel:+46451744400";
const SUPPORT_EMAIL = "support@pol.se";

export default function SupportContact() {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center mb-1">
        <FontAwesomeIcon icon={faPhone} className="me-2 text-primary" />
        <a
          href={SUPPORT_PHONE_HREF}
          className="text-reset text-decoration-none"
        >
          {SUPPORT_PHONE}
        </a>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary" />
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="text-reset text-decoration-none"
        >
          {SUPPORT_EMAIL}
        </a>
      </div>
    </>
  );
}
